import $ from 'jquery'

/**
 * Variables
 */

const pageHasAccordion = $('[data-accordion-section]')

/**
 * Initialisation
 */

export function init() {
  $(window).on('load', function () {
    if (window.location.hash && pageHasAccordion.length > 0) {
      const hash = window.location.hash.slice(1)
      $.when(scrollToAnchor(hash)).then(openAccordionItem(hash))
    }
  })
}

function openAccordionItem(hash) {
  const $this = $('[data-toggle="' + hash + '"]')
  const $target = $('[data-toggle-target="' + hash + '"]')

  $this.toggleClass('open')
  $target.toggleClass('open')
}

function scrollToAnchor(hash) {
  let position = 0

  position = $('a[name="' + hash + '"]')
    .parents('section')
    .first()
    .position().top

  const scroll = $(window).scrollTop()
  const time = Math.min(Math.abs(scroll - position) / 3, 1500) // distance / 3, or 1.5 seconds max

  $('html, body').animate({ scrollTop: position }, time, 'swing')
}
